import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Environment,
  ISchedeInterventoModel,
  ISchedeIntervento_CountModel,
  MagazzinoMovimentiModel,
  MagazzinoMovimenti_TableModel,
  ModelNumStr,
  SchedeIntervento,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class SchedeInterventoService extends CrudGenericsService<SchedeIntervento, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/SchedeIntervento`);
    this.base = `${env.apiUrl}/api/SchedeIntervento/`;
  }
  // web
  Get4Select_ByTicket(id: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByTicket?id=${id}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  // web ticket view
  GetAll_SchedaIntMoviMag_ByTicket(id: number): Observable<MagazzinoMovimentiModel[]> {
    const u = `${this.base}GetAll_SchedaIntMoviMag_ByTicket?id=${id}`;
    return this.http.get<MagazzinoMovimentiModel[]>(u);
  }

  // ionic
  GetSingle_SchedeInterventoModel_ByScheda(id: number): Observable<ISchedeInterventoModel> {
    const u = `${this.base}GetSingle_SchedeInterventoModel_ByScheda?id=${id}`;
    return this.http.get<ISchedeInterventoModel>(u);
  }
  // ionic buttons
  SchedeIntervento_CountByTicket(id: number): Observable<ISchedeIntervento_CountModel> {
    const u = `${this.base}SchedeIntervento_CountByTicket?id=${id}`;
    return this.http.get<ISchedeIntervento_CountModel>(u);
  }
  // ionic
  GetAll_SchedeInterventoModel_ByTicket(id: number): Observable<ISchedeInterventoModel[]> {
    const u = `${this.base}GetAll_SchedeInterventoModel_ByTicket?id=${id}`;
    return this.http.get<ISchedeInterventoModel[]>(u);
  }
}
